import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-mr-2" }
const _hoisted_6 = { class: "p-d-flex p-flex-row p-flex-wrap" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_8 = { class: "p-mr-2" }
const _hoisted_9 = { class: "p-d-flex p-flex-row p-flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chip = _resolveComponent("Chip")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      header: _ctx.$t('managers.glossary.glossaryDefinition.details'),
      breakpoints: _ctx.glossaryDefinitionDialogDescriptor.dialog.breakpoints,
      style: _ctx.glossaryDefinitionDialogDescriptor.dialog.style,
      visible: _ctx.visible,
      modal: true,
      class: "glossaryDefinitionDetail p-fluid kn-dialog--toolbar--primary",
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_ctx.contentInfo && _ctx.contentInfo.CONTENT_ID)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("ul", null, [
                _createVNode("li", null, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('common.name')) + ":", 1),
                  _createVNode("span", null, _toDisplayString(_ctx.contentInfo.CONTENT_NM), 1)
                ]),
                _createVNode("li", null, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.code')) + ":", 1),
                  _createVNode("span", null, _toDisplayString(_ctx.contentInfo.CONTENT_CD), 1)
                ]),
                _createVNode("li", null, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('common.description')) + ":", 1),
                  _createVNode("span", null, _toDisplayString(_ctx.contentInfo.CONTENT_DS), 1)
                ])
              ])
            ]))
          : (_ctx.contentInfo?.WORD_ID)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$tc('managers.glossary.common.word', 1)) + ":", 1),
                    _createVNode("span", null, _toDisplayString(_ctx.contentInfo.WORD), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.status')) + ":", 1),
                    (_ctx.contentInfo.STATE_NM)
                      ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.glossaryDefinitionDescriptor.translation[_ctx.contentInfo.STATE_NM])), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.category')) + ":", 1),
                    (_ctx.contentInfo.CATEGORY_NM)
                      ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.glossaryDefinitionDescriptor.translation[_ctx.contentInfo.CATEGORY_NM])), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('common.description')) + ":", 1),
                    _createVNode("span", null, _toDisplayString(_ctx.contentInfo.DESCR), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.formula')) + ":", 1),
                    _createVNode("span", null, _toDisplayString(_ctx.contentInfo.FORMULA), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('managers.glossary.common.link')) + ":", 1),
                    _createVNode("div", _hoisted_6, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentInfo.LINK, (link, index) => {
                        return (_openBlock(), _createBlock(_component_Chip, {
                          class: "p-m-1",
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(link.WORD), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.attributes')) + ":", 1),
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentInfo.SBI_GL_WORD_ATTR, (attribute, index) => {
                        return (_openBlock(), _createBlock("li", { key: index }, [
                          _createVNode("span", null, _toDisplayString(attribute.ATTRIBUTE_NM) + ":", 1),
                          _hoisted_7,
                          _createVNode("ul", null, [
                            _createVNode("li", _hoisted_8, _toDisplayString(attribute.VALUE), 1),
                            _createVNode("div", _hoisted_9, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentInfo.LINK, (link, index) => {
                                return (_openBlock(), _createBlock(_component_Chip, {
                                  class: "p-m-1",
                                  key: index
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(link.WORD), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["header", "breakpoints", "style", "visible"])
  ]))
}